import React from 'react';
import { motion } from 'framer-motion';
import LazyFacebookVideo from '../shared/LazyFacebookVideo';

export default function ClientMomentSection() {
  return (
    <section className="relative py-20 md:py-28 bg-[#111111] border-t border-white/10">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <div className="w-12 h-px bg-[#C97B2E] mx-auto mb-6" />
          <span className="font-body text-[#C97B2E] text-xs font-bold uppercase tracking-[0.3em] mb-4 block">
            Behind the Scenes
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">
            Actual Conversations With Our Clients
          </h2>
          <p className="font-body text-white/50 text-base max-w-xl mx-auto">
            We take the work seriously. Ourselves? A little less so.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex justify-center"
        >
          <div className="w-full max-w-[300px] rounded-sm overflow-hidden shadow-md bg-[#0a0a0a]">
            <LazyFacebookVideo
              src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1986254318649674%2F&show_text=false&width=267&t=0"
              title="Terza Costa Construction — actual conversations with our clients"
              poster="/images/reel-client-conversations-poster.jpg"
              posterAlt="Justin of Terza Costa Construction talking with a client on site"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
